// extracted by mini-css-extract-plugin
export default {"time":"c7b08a"};